import React, {  useState} from "react";
import {Alert, Button, Col, DatePicker, Form, Input, Row} from "antd";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import dayjs from "dayjs";
import { LoginUser, RecoverPassword, ValidateEmailToRecover} from "../../utils/AuthFunctions";
import "./formLogin.scss";
import {IoMdClose} from "react-icons/io";
import { LoginProviderTypes } from "../../enums/LoginProviderTypes";
import {LoginProviders} from "../loginProviders/loginProviders";
import DetectGoogleBlock from "../../helpers/adBlockDetector";

const FormLogin = ({isFormModal = false, isFormLogin, setIsFormLogin, handleCancel, handleFormSubmit, textRegister = null, title, setMsg, msg}) => {
    const [form] = Form.useForm();
    const accountSettings = useSelector((state) => state.accountSettings);
    const [isCorporateUser, setIsCorporateUser] = useState(false);
    const [isGranted, setIsGranted] = useState(false);
    const [isRecovery, setIsRecovery] = useState(false);
    const history = useHistory();
    const [currentDate] = useState(dayjs().subtract(18, "years"));
    const [isLoading, setIsLoading] = useState(false);

    const handleDisabledDate = (current) => dayjs().subtract(18, "years") < current;

    const onSubmit = async (values) => {
        setMsg("");
        setIsLoading(true);

        const baseParams = {
            username: values.email,
            password: values.password,
            productSubscription: accountSettings.productSubscription,
            provider: LoginProviderTypes.PASSWORD,
            idToken: "",
            code: "",
            nonce: "",
            firstName: "",
            lastName: ""
        };

        if (isFormLogin) {
            const logued = await LoginUser(baseParams);
            if (logued.success) {
                if (logued.roleName === "Operaciones")
                    history.push("/operator");
                if (logued.responseCode === "11")
                    history.push({ pathname: "/membership", state: logued });

                window.location.reload();
            } else {
                setMsg(logued.msg);
                setIsLoading(false);
            }
        } else {
            const emailValidated = await ValidateEmailToRecover({ email: values.email });
            if (!emailValidated || emailValidated === "El usuario no está registrado o aún no ha sido confirmado.") {
                setIsLoading(false);
                return setMsg(emailValidated);
            }
            if (emailValidated) {
                setIsCorporateUser(emailValidated.isCorporateUser);
                if (emailValidated.userId !== undefined) setIsGranted(true);
                if (emailValidated.isCorporateUser || emailValidated.additionalEmail) setIsRecovery(true);

                if (emailValidated.userId !== undefined) {
                    handleFormSubmit(
                        true,
                        "Se ha enviado un link a tu correo para reestablecer tu contraseña",
                        "Revisa tu bandeja de correo",
                        true,
                        false
                    );
                    setIsLoading(false);
                    return await RecoverPassword({
                        ...values,
                        CompanyId: process.env.REACT_APP_COMPANY,
                        IsRegistered: emailValidated.isCorporateUser
                    });
                }
            }
        }
    };

    return (
        <Form form={form} className="form-light small" onFinish={onSubmit} layout="vertical">
            <Row gutter={[0, 8]}>
                <Col span={24}>
                    {
                        (isFormLogin) ? <>
                                <h4>{title}</h4>
                                <p className={"text-informative"}>Regístrate o inicia sesión en PrideMx</p>
                                {(textRegister) ? textRegister : ""}
                            </> :
                            <>
                                <h4>Cambia tu contraseña</h4>
                                {
                                    (!(isRecovery) && isGranted && !isCorporateUser) ?
                                        <p>Es necesario efectuar una comprobación de identidad. Captura los siguientes datos:</p>
                                        :
                                        <p className={"text-informative"}>Te enviaremos un correo para que cambies tu contraseña</p>
                                }
                            </>
                    }
                </Col>

                {msg !== "" && (
                    <Col xs={24} style={{ marginTop: "1rem" }}>
                        <Alert message={msg} type="warning" showIcon closable />
                    </Col>
                )}

                <Col xs={24}>
                    <Form.Item
                        label="Tu correo"
                        name="email"
                        rules={[
                            { required: true, message: "*Campo requerido" },
                            { type: "email", message: "No es un formato de correo válido" }
                        ]}
                    >
                        <Input size="large" />
                    </Form.Item>
                </Col>

                {isFormLogin && (
                    <Col xs={24}>
                        <Form.Item label="Contraseña" name="password" rules={[{ required: true, message: "*Campo requerido" }]}>
                            <Input.Password size="large" />
                        </Form.Item>
                    </Col>
                )}

                {!(isRecovery) && isGranted && !isCorporateUser && (
                    <>
                        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                            <Form.Item
                                label={"Tu cumpleaños"}
                                name={"Birthday"}
                                htmlFor={"Birthday"}
                                rules={[{ required: true, message: "*Campo requerido" }]}
                            >
                                <DatePicker
                                    name={"Birthday"}
                                    size={"large"}
                                    placeholder={"Cumpleaños"}
                                    picker={"date"}
                                    showToday={false}
                                    onFocus={() => form.setFieldValue("Birthday", currentDate)}
                                    disabledDate={handleDisabledDate}
                                    format={"DD/MMM/YYYY"}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item
                                label={"Correo Electrónico para recuperar contraseña"}
                                name={"AdditionalEmail"}
                                htmlFor={"AdditionalEmail"}
                                rules={[
                                    { required: true, message: "*Campo requerido" },
                                    { type: "email", message: "No es un formato de correo válido" }
                                ]}
                            >
                                <Input name={"AdditionalEmail"} size={"large"} />
                            </Form.Item>
                        </Col>
                    </>
                )}

                <Col xs={24}>
                    <button
                        type={"button"}
                        className={"forgot-password"}
                        onClick={() => {
                            setIsFormLogin(!isFormLogin);
                            setMsg("");
                        }}
                    >
                        {isFormLogin ? "¿Olvidaste tu contraseña?" : "Ya tengo una cuenta"}
                    </button>
                </Col>

                <div className="form-light__footer">
                    {(isFormModal) && (
                        <Button type="default" onClick={handleCancel} block={true} disabled={isLoading}>
                            Cerrar
                        </Button>
                        )
                    }
                    <Button
                        htmlType="submit"
                        type="primary"
                        block={true}
                        loading={isLoading}
                    >
                        {(isFormLogin) ? "Ingresar" :"Enviar Correo"}
                    </Button>
                </div>
                <DetectGoogleBlock />
                {(isFormLogin) && (
                    <Col xs={24}>
                       <LoginProviders
                           setMsg={setMsg}
                           textDivider={"O ingresar con"}
                           isLogin={true}
                       />
                    </Col>
                )
                }
            </Row>
        </Form>
    );
};

export default FormLogin;